import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const activeItem = location.pathname.split('/')[1] || 'dashboard';

  const menuItems = [
    { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { id: 'homepage', path: '/homepage', icon: '🏠', label: 'Homepage' },
    { id: 'users', path: '/users', icon: '👥', label: 'Users' },
    { id: 'restaurants', path: '/restaurants', icon: '🏢', label: 'Restaurants', badge: '5' },
    { id: 'orders', path: '/orders', icon: '📋', label: 'Orders', badge: '12' },
    { id: 'deals', path: '/deals', icon: '💎', label: 'Deals' },
    { id: 'transactions', path: '/transactions', icon: '💳', label: 'Transactions' },
    { id: 'payouts', path: '/payouts', icon: '💰', label: 'Payouts' },
    { id: 'reports', path: '/reports', icon: '📈', label: 'Reports' },
    { id: 'documents', path: '/documents', icon: '📑', label: 'Documents', badge: '3' },
    { id: 'analytics', path: '/analytics', icon: '📊', label: 'Analytics' },
    { id: 'notifications', path: '/notifications', icon: '🔔', label: 'Notifications' },
    { id: 'settings', path: '/settings', icon: '⚙️', label: 'Settings' },
  ];

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        {!collapsed && <div className="sidebar-logo">GullyPick Admin</div>}
        <button className="sidebar-toggle" onClick={onToggle} aria-label="Toggle sidebar">
          {collapsed ? '→' : '←'}
        </button>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className={`sidebar-item ${activeItem === item.id ? 'active' : ''}`}
            title={collapsed ? item.label : ''}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {!collapsed && <span className="sidebar-label">{item.label}</span>}
            {!collapsed && item.badge && <span className="sidebar-badge">{item.badge}</span>}
            {collapsed && item.badge && (
              <span className="sidebar-badge-collapsed">{item.badge}</span>
            )}
          </Link>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">JD</div>
          {!collapsed && (
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">John Doe</div>
              <div className="sidebar-user-role">Admin</div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;

